export default __webpack_public_path__ + "static/media/BF.7be5aafb.svg";